import React from "react";

const Input = React.forwardRef(
  (
    {
      className = "block w-full",
      labelKey,
      name,
      errorKey,
      placeholderKey,
      variant = "normal",
      shadow = false,
      type = "text",
      inputClassName,
      setError,
      border = "border-[0.5px] border-solid border-darkGrey/50",
      ...rest
    },
    ref
  ) => {
    return (
      <div className="w-full">
        {labelKey && (
          <label
            htmlFor={name}
            className={`block text-darkGrey/50 font-normal text-sm leading-none mb-2`}
          >
            {labelKey}
          </label>
        )}
        <input
          id={name}
          name={name}
          type={type}
          ref={ref}
          // @ts-ignore
          placeholder={placeholderKey}
          className={`w-full shrink-0 py-4 z-[1] px-4 placeholder:text-darkGrey/50 text-sm md:placeholder:text-sm placeholder:text-xs focus:outline-none outline-none text-darkGrey rounded-full bg-inherit ${border}`}
          autoComplete="off"
          spellCheck="false"
          aria-invalid={errorKey ? "true" : "false"}
          {...rest}
        />
        {errorKey && <p className="my-2 text-xs text-red-500">{errorKey}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";
export default Input;
